import { Contract } from '@ethersproject/contracts';
import { useContract, Contracts } from './useContract';

export function useTokenContract(tokenAddress?: string, networkId?: number): Contract | null {
  return useContract(tokenAddress, Contracts.ERC20, networkId);
}
